<template>
  <PublicLayout>
    <h1 class="public__title">Politique de cookies</h1>
    <p class="public__lead">
      Saineo utilise des cookies pour améliorer l’expérience utilisateur et mesurer l’usage du service.
    </p>

    <h2 class="public__section-title">Types de cookies</h2>
    <ul class="public__list">
      <li>Cookies essentiels au fonctionnement</li>
      <li>Cookies de performance et d’analyse</li>
      <li>Cookies de personnalisation</li>
    </ul>

    <h2 class="public__section-title">Gestion</h2>
    <p class="public__text">
      Vous pouvez modifier vos préférences via les paramètres de votre navigateur à tout moment.
    </p>
  </PublicLayout>
</template>

<script>
import PublicLayout from './PublicLayout.vue';

export default {
  name: 'CookiesPage',
  components: { PublicLayout },
};
</script>
